import { GoldThreadLine } from "@/components/SparkSun";

// Quiet marker: Spark is drawing on a Gold Thread the client confirmed — always named as theirs.
export const ThreadEcho = ({ theme, className = "" }) => {
  if (!theme) return null;
  return (
    <p data-testid="thread-echo" className={`flex items-center gap-3 text-xs ${className}`} style={{ color: "#A6894F" }}>
      <GoldThreadLine className="w-10 h-2 shrink-0" />
      <span>Echoes the Gold Thread you named: <span className="font-semibold">{theme}</span></span>
    </p>
  );
};

export default ThreadEcho;
